import { Component, OnInit, Input, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef, Output,
    EventEmitter } from '@angular/core';

import { EuiUploadedFile } from '../models/uploaded-file.model';

@Component({
    selector: 'eui-file-preview',
    templateUrl: './file-preview.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiFilePreviewComponent implements OnInit {
    @Input() file: Blob | EuiUploadedFile | any;
    @Input() index: number;
    @Input() hasPreview = true;
    @Input() isFilenameDisplayed = true;
    @Input() isFilesizeDisplayed = true;
    @Input() isFiletypeDisplayed = true;
    @Input() hasPreviewAsImage = true;
    @Input() hasPreviewAsIcon = false;

    @Input() previewAsIconConfig = {
        'avi': 'eui-icon-filetype-avi',
        'html': 'eui-icon-filetype-html',
        'htm': 'eui-icon-filetype-html',
        'js': 'eui-icon-filetype-js',
        'json': 'eui-icon-filetype-json',
        'mp4': 'eui-icon-filetype-mp4',
        'pdf': 'eui-icon-filetype-pdf',
        'png': 'eui-icon-filetype-png',
        'svg': 'eui-icon-filetype-svg',
        'txt': 'eui-icon-filetype-txt',
        'xml': 'eui-icon-filetype-xml',
        'jpeg': 'eui-icon-filetype-jpg',
        'jpg': 'eui-icon-filetype-jpg',
        'zip': 'eui-icon-filetype-zip',
        'doc': 'eui-icon-filetype-doc',
        'docx': 'eui-icon-filetype-doc',
        'xls': 'eui-icon-filetype-xls',
        'xlsx': 'eui-icon-filetype-xls',
        'ppt': 'eui-icon-filetype-ppt',
        'csv': 'eui-icon-filetype-csv',
        'rtf': 'eui-icon-filetype-rtf',
    };

    @Output() removeFromList = new EventEmitter<number>();

    public url: string;
    public icon: string;
    public fileExtension: string;
    public previewData: { image: boolean, display: string };

    constructor(private cd: ChangeDetectorRef) { }

    ngOnInit() {
        if (this.hasPreviewAsIcon) {
            this.hasPreviewAsImage = false;
        }

        if (this.file instanceof Blob) {
            const reader = new FileReader();
            reader.readAsDataURL(this.file as Blob);
            reader.onload = (event: any) => {
                this.url = event.target.result;
                this.fileExtension = this.getFileExtension(this.file.name);
                this.icon = this.getIconForMime(this.fileExtension);
                this.previewData = this.getPreviewForMime(this.fileExtension);
                this.cd.detectChanges();
            };
        } else {
            this.url = (this.file as EuiUploadedFile).url;
            this.fileExtension = this.getFileExtension(this.file.name);
            this.icon = this.getIconForMime(this.fileExtension);
            this.previewData = this.getPreviewForMime(this.fileExtension);
            this.cd.detectChanges();
        }
    }

    public onRemoveFromList() {
        this.removeFromList.emit(this.index);
    }

    private getFileExtension(fileName: string) {
        const ext = fileName.split('.');

        return ext[ext.length - 1];
    }

    private getPreviewForMime(fileExtension: string) {
        const image = fileExtension === 'jpeg' || fileExtension === 'jpg' || fileExtension === 'png' ||
            fileExtension === 'gif' ? true : false;

        const display = fileExtension === 'jpeg' || fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'gif' ?
                                    this.url :
                                    this.getIconForMime(fileExtension);

        return { image, display };
    }

    private getIconForMime(fileExtension: string) {
        return !this.previewAsIconConfig[fileExtension] ? 'eui-icon-filetype-unknown' : this.previewAsIconConfig[fileExtension];
    }
}
